document.addEventListener("DOMContentLoaded", async function () {

    // Elements
    const shippingProtectionCheckbox = document.getElementById("shippingProtectionCheckbox");
    const cartDrawerCheckbox = document.querySelector("#CartDrawer #shippingProtectionCheckbox");
    const protectionPriceElements = document.querySelectorAll(".protection-price");
    const checkoutButtons = document.querySelectorAll("button[name='checkout']");
    const productQuantityElement = document.querySelector("input[name='quantity']");
    const cartDrawerFooter = document.querySelector(".cart-drawer__footer");

    // Variant data (make sure .protection_text exists and has data attributes)
    const protectionVariantId = document.querySelector(".protection_text")?.getAttribute("data-variant-id");
    const protectionBasePrice = parseFloat(document.querySelector(".protection_text")?.getAttribute("data-variant-price")) || 0;

    // -----------------------
    // Helpers
    // -----------------------
    async function getCart() {
        const res = await fetch("/cart.js");
        return await res.json();
    }

    async function updateAttributes(state) {
        return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: { shipping_protection_toggle_state: state } })
        });
    }

    // count non-protection product quantity (items we want protection for)
    function countNonProtectionItems(cart) {
        return cart.items.reduce((count, item) => {
            return item.id == protectionVariantId ? count : count + item.quantity;
        }, 0);
    }

    // If protection present in cart, return the item object
    function findProtectionItem(cart) {
        return cart.items.find(item => item.id == protectionVariantId);
    }

    // Update protection price labels (what user sees per protection total)
    function updatePriceUI(price) {
        protectionPriceElements.forEach(el => el.textContent = parseFloat(price).toFixed(2));
    }

    // Update the totals UI WITHOUT double counting protection
    // If protection is already in cart, use cart.items_subtotal_price (already includes protection).
    // If protection is not in cart but toggle enabled, add computed protection to subtotal.
    function updateCartTotalUI(cart, computedProtectionPriceWhenNotInCart) {
        const subtotalEl = document.querySelector(".totals__subtotal-value");
        if (!subtotalEl) return;

        const cartSubtotal = cart.items_subtotal_price / 100; // already includes protection if present
        const protectionItem = findProtectionItem(cart);
        let displayedTotal;

        if (protectionItem) {
            // protection already baked into cart subtotal
            displayedTotal = cartSubtotal;
        } else {
            // protection not present in cart: add computed protection price (could be 0)
            displayedTotal = (cartSubtotal + parseFloat(computedProtectionPriceWhenNotInCart || 0)).toFixed(2);
        }

        // Keep same textual formatting (currency symbol / suffix) using regex
        const text = subtotalEl.textContent.trim();
        const match = text.match(/^([\D]*)(\d+(\.\d+)?)(.*)$/);
        if (match) {
            subtotalEl.textContent = `${match[1]}${parseFloat(displayedTotal).toFixed(2)}${match[4]}`;
        } else {
            // fallback just replace numeric content
            subtotalEl.textContent = parseFloat(displayedTotal).toFixed(2);
        }
    }

    // -----------------------
    // Core calculators
    // -----------------------
    // Calculate what protection price should be shown and update totals correctly
    async function calculateProtectionPriceAndTotals() {
        const cart = await getCart();
        const nonProtectionQty = countNonProtectionItems(cart);
        const protectionItem = findProtectionItem(cart);
        const toggleEnabled = cart.attributes?.shipping_protection_toggle_state !== "0"; // default ON if undefined

        let protectionPriceToShow = 0;

        if (protectionItem) {
            // If protection is already added, show its line total (use product quantity * base price).
            // Shopify's cart item final_line_price includes currency formatting; we calculate from base price to be consistent.
            protectionPriceToShow = (protectionItem.quantity * protectionBasePrice);
            updatePriceUI(protectionPriceToShow);
            updateCartTotalUI(cart, 0);
            return;
        }

        // Not present in cart
        if (toggleEnabled && nonProtectionQty > 0) {
            protectionPriceToShow = protectionBasePrice * nonProtectionQty;
        } else {
            protectionPriceToShow = 0;
        }

        updatePriceUI(protectionPriceToShow);
        updateCartTotalUI(cart, protectionPriceToShow);
    }

    // -----------------------
    // Add / Remove protection
    // -----------------------
    async function ensureProtectionAddedOnce() {
        // Add protection product only if toggle is ON, protection not present, and there are real items
        const cart = await getCart();
        const toggleEnabled = cart.attributes?.shipping_protection_toggle_state !== "0"; // default ON
        const nonProtectionQty = countNonProtectionItems(cart);
        const protectionItem = findProtectionItem(cart);

        if (toggleEnabled && !protectionItem && nonProtectionQty > 0) {
            await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: protectionVariantId, quantity: nonProtectionQty })
            });
            // Give Shopify a short moment to update
            await new Promise(r => setTimeout(r, 350));
        }
    }

    async function removeProtectionIfExists() {
        const cart = await getCart();
        const protectionItem = findProtectionItem(cart);
        if (!protectionItem) return;

        // To remove, use the item's key (line key) with change.js
        await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: protectionItem.key, quantity: 0 })
        });

        await new Promise(r => setTimeout(r, 350));
    }

    // -----------------------
    // Toggle handler
    // -----------------------
    async function handleToggle(checked) {
        // Update cart attributes first
        await updateAttributes(checked ? "1" : "0");

        if (checked) {
            // Add protection if not present (one-time add)
            await ensureProtectionAddedOnce();
        } else {
            // Remove protection if present (use key)
            await removeProtectionIfExists();
        }

        // Recalculate UI
        await calculateProtectionPriceAndTotals();
    }

    // -----------------------
    // Checkout handler
    // -----------------------
    async function handleCheckoutClick(e) {
        e.preventDefault();

        const cart = await getCart();
        const enabled = cart.attributes?.shipping_protection_toggle_state !== "0";
        const protectionItem = findProtectionItem(cart);
        const nonProtectionQty = countNonProtectionItems(cart);

        if (enabled && !protectionItem && nonProtectionQty > 0) {
            // add and wait
            await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: protectionVariantId, quantity: nonProtectionQty })
            });
            await new Promise(r => setTimeout(r, 450));
        }

        // finally go to checkout
        window.location.href = "/checkout";
    }

    // -----------------------
    // Event listeners
    // -----------------------
    shippingProtectionCheckbox?.addEventListener("change", (e) => handleToggle(e.target.checked));
    cartDrawerCheckbox?.addEventListener("change", (e) => handleToggle(e.target.checked));

    checkoutButtons.forEach(btn => btn.addEventListener("click", handleCheckoutClick));

    if (cartDrawerFooter) {
        cartDrawerFooter.addEventListener("click", function (event) {
            if (event.target.matches("button[name='checkout']")) {
                event.preventDefault();
                handleCheckoutClick(event);
            }
        });
    }

    productQuantityElement?.addEventListener("change", async function () {
        // When product quantity changes on product page, update protection product UI (not cart)
        // No cart calls here because this is on product page before adding to cart.
        const qty = parseInt(this.value, 10) || 1;
        updatePriceUI(protectionBasePrice * qty);
    });

    // If theme code dispatches cart:updated events, recalculate UI
    document.addEventListener("cart:updated", calculateProtectionPriceAndTotals);

    // -----------------------
    // Initialization sequence
    // -----------------------
    // 1) Ensure protection auto-added once if toggle default is ON
    await ensureProtectionAddedOnce();

    // 2) Calculate and show correct price & totals (no double-count)
    await calculateProtectionPriceAndTotals();

});
